export const maxText = (text: string, maxLength: number): string => {
  if (text) {
    return `${text.substring(0, maxLength)} ${text.length > maxLength ? '...' : ''}`;
  }
  return '';
};
